import axios from 'axios';

// Forzar tipos de variables en el payload
export function preparePayload(data) {
    return {
        target_height: parseFloat(data.target_height),
        target_latitude: parseFloat(data.target_latitude),
        target_longitude: parseFloat(data.target_longitude),
        security_takeoff_height: parseFloat(data.security_takeoff_height),
        max_speed: parseFloat(data.max_speed),
        rc_lost_action: String(data.rc_lost_action),
        rth_altitude: parseFloat(data.rth_altitude),
        exit_wayline_when_rc_lost: Boolean(data.exit_wayline_when_rc_lost),
        commander_mode_lost_action: String(data.commander_mode_lost_action),
        commander_flight_mode: String(data.commander_flight_mode),
        commander_flight_height: parseFloat(data.commander_flight_height),
        rth_mode: String(data.rth_mode),
        dock_sn: String(data.dock_sn),
        drone_sn: String(data.drone_sn),
        token: String(data.token),
    };
}

export const registryGoTo = async (payload) => {
        const url = "https://goto.cvis.videri.ai/go_to_point"
        const forcedPayload = preparePayload(payload);
        const result = await axios.post(url, forcedPayload, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return result;
}